import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/axios";

interface ChartFilters {
    startDate?: Date | null;
    endDate?: Date | null;
    userId?: string;
    projectSelected?: string;
    userSelected?: string;
    type?: string;
    region?: string,
    cordination?: string,
    principal?: string,
    master?: string,
}

export const useDetailFunnelHealth = (filters: ChartFilters) => useQuery({
    queryKey: ["detail-funnel-health", filters],
    queryFn: async ({ queryKey }) => {
        const [, filters] = queryKey as [string, ChartFilters];
        const response = await api.get(`/dashboard/detail-funnel-health`, {
            params: {
                startDate: filters.startDate?.toISOString(),
                endDate: filters.endDate?.toISOString(),
                userId: filters.userId,
                projectSelected: filters.projectSelected,
                userSelected: filters.userSelected,
                type: filters.type,
                region: filters.region,
                cordination: filters.cordination,
                principal: filters.principal,
                master: filters.master,
            },
        });
        return response.data;
    },
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    initialData: []
});
